/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import getters from '@/store/modules/listing/getters'

getters.getTotals = (state) => {
  return state.pagination.total
}

getters.filterSelected = (state) => {
  return state.filters.chosen ? state.filters.chosen : []
}

getters.filterParentMap = (state) => {
  let availableFilter = state.filters.available
  let filterMap = {}
  for (let i in availableFilter) {
    if (availableFilter[i] && availableFilter[i].options) {
      availableFilter[i].options.forEach(opt => {
        if (opt.value === 'price') {
          let label = opt.label.split('_')
          opt.label = `${label[0]} € - ${label[1]} €`
        }
        filterMap[opt.value] = opt
      })
    }
  }
  return filterMap
}

getters.getColumnView = (state) => {
  return state.columnsView
}

export default {
  ...getters
}
